/**
 * Runtime config, read from Vite env at build time.
 *
 *   VITE_API_BASE_URL   — the Axlerun API origin the public endpoints live on.
 *                         Defaults to sandbox so `npm run dev` works out of the
 *                         box; set per-environment at build.
 *   VITE_GOOGLE_MAPS_KEY — browser (JS) Google Maps key, referrer-restricted to
 *                         the portal host. Optional: the page renders job detail
 *                         without it and simply omits the live map.
 */

export const API_BASE_URL: string =
  import.meta.env.VITE_API_BASE_URL?.replace(/\/$/, '') ??
  'https://sandbox-api.axlerun.com.au';

export const GOOGLE_MAPS_KEY: string = import.meta.env.VITE_GOOGLE_MAPS_KEY ?? '';

/** Poll cadence for the vehicle location while the driver is en route (ms). */
export const LOCATION_POLL_MS = 8000;
